// src/modules/app-views/serviceOrders/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import StatusTag from 'modules/app-views/serviceOrders/components/StatusTag';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 130,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => <StatusTag status={r?.status} />,
  };
}

export default statusColumn;
